import React from 'react';

const DroneSVG = () => (
  <svg
    viewBox="0 0 520 380"
    xmlns="http://www.w3.org/2000/svg"
    className="drone-svg"
    aria-label="DJI Drone"
  >
    {/* ── PROPELLER BLUR RINGS ── */}
    {/* Top-left */}
    <ellipse cx="108" cy="108" rx="88" ry="18" fill="none" stroke="rgba(226,0,26,0.15)" strokeWidth="2" />
    <ellipse cx="108" cy="108" rx="76" ry="14" fill="none" stroke="rgba(226,0,26,0.10)" strokeWidth="1" />
    {/* Top-right */}
    <ellipse cx="412" cy="108" rx="88" ry="18" fill="none" stroke="rgba(226,0,26,0.15)" strokeWidth="2" />
    <ellipse cx="412" cy="108" rx="76" ry="14" fill="none" stroke="rgba(226,0,26,0.10)" strokeWidth="1" />
    {/* Bottom-left */}
    <ellipse cx="108" cy="272" rx="88" ry="18" fill="none" stroke="rgba(226,0,26,0.15)" strokeWidth="2" />
    <ellipse cx="108" cy="272" rx="76" ry="14" fill="none" stroke="rgba(226,0,26,0.10)" strokeWidth="1" />
    {/* Bottom-right */}
    <ellipse cx="412" cy="272" rx="88" ry="18" fill="none" stroke="rgba(226,0,26,0.15)" strokeWidth="2" />
    <ellipse cx="412" cy="272" rx="76" ry="14" fill="none" stroke="rgba(226,0,26,0.10)" strokeWidth="1" />

    {/* ── ARMS ── */}
    <line x1="108" y1="108" x2="210" y2="180" stroke="#2a2a2a" strokeWidth="10" strokeLinecap="round" />
    <line x1="412" y1="108" x2="310" y2="180" stroke="#2a2a2a" strokeWidth="10" strokeLinecap="round" />
    <line x1="108" y1="272" x2="210" y2="200" stroke="#2a2a2a" strokeWidth="10" strokeLinecap="round" />
    <line x1="412" y1="272" x2="310" y2="200" stroke="#2a2a2a" strokeWidth="10" strokeLinecap="round" />

    {/* ── ARM HIGHLIGHTS ── */}
    <line x1="108" y1="105" x2="210" y2="177" stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
    <line x1="412" y1="105" x2="310" y2="177" stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
    <line x1="108" y1="269" x2="210" y2="197" stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
    <line x1="412" y1="269" x2="310" y2="197" stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />

    {/* ── MOTOR HOUSINGS ── */}
    {[108, 412].map((x) =>
      [108, 272].map((y) => (
        <g key={`${x}-${y}`}>
          <circle cx={x} cy={y} r="22" fill="#1a1a1a" stroke="#333" strokeWidth="2" />
          <circle cx={x} cy={y} r="14" fill="#222" stroke="#e2001a" strokeWidth="1.5" />
          <circle cx={x} cy={y} r="6" fill="#e2001a" />
        </g>
      ))
    )}

    {/* ── SPINNING PROPELLERS ── */}
    {/* Top-left props */}
    <g style={{ transformOrigin: '108px 108px', animation: 'spinProp 0.3s linear infinite' }}>
      <rect x="22" y="105" width="172" height="6" rx="3" fill="#1a1a1a" opacity="0.85" />
      <rect x="105" y="22" width="6" height="172" rx="3" fill="#1a1a1a" opacity="0.85" />
    </g>
    {/* Top-right props */}
    <g style={{ transformOrigin: '412px 108px', animation: 'spinProp 0.3s linear infinite reverse' }}>
      <rect x="326" y="105" width="172" height="6" rx="3" fill="#1a1a1a" opacity="0.85" />
      <rect x="409" y="22" width="6" height="172" rx="3" fill="#1a1a1a" opacity="0.85" />
    </g>
    {/* Bottom-left props */}
    <g style={{ transformOrigin: '108px 272px', animation: 'spinProp 0.3s linear infinite reverse' }}>
      <rect x="22" y="269" width="172" height="6" rx="3" fill="#1a1a1a" opacity="0.85" />
      <rect x="105" y="186" width="6" height="172" rx="3" fill="#1a1a1a" opacity="0.85" />
    </g>
    {/* Bottom-right props */}
    <g style={{ transformOrigin: '412px 272px', animation: 'spinProp 0.3s linear infinite' }}>
      <rect x="326" y="269" width="172" height="6" rx="3" fill="#1a1a1a" opacity="0.85" />
      <rect x="409" y="186" width="6" height="172" rx="3" fill="#1a1a1a" opacity="0.85" />
    </g>

    {/* ── MAIN BODY ── */}
    {/* Body shell */}
    <rect x="195" y="158" width="130" height="64" rx="16" fill="#1e1e1e" />
    <rect x="198" y="161" width="124" height="58" rx="14" fill="#252525" />
    {/* Top ridge */}
    <rect x="220" y="155" width="80" height="12" rx="6" fill="#1a1a1a" stroke="#333" strokeWidth="1" />
    {/* DJI red accent stripe */}
    <rect x="195" y="178" width="130" height="4" rx="2" fill="#e2001a" opacity="0.9" />
    {/* Body side vents */}
    <rect x="200" y="168" width="16" height="3" rx="1.5" fill="#333" />
    <rect x="200" y="174" width="16" height="3" rx="1.5" fill="#333" />
    <rect x="304" y="168" width="16" height="3" rx="1.5" fill="#333" />
    <rect x="304" y="174" width="16" height="3" rx="1.5" fill="#333" />

    {/* ── CAMERA GIMBAL ── */}
    {/* Gimbal mount arm */}
    <rect x="246" y="218" width="28" height="10" rx="4" fill="#181818" stroke="#2a2a2a" strokeWidth="1" />
    {/* Gimbal housing */}
    <ellipse cx="260" cy="238" rx="24" ry="20" fill="#181818" stroke="#2a2a2a" strokeWidth="1.5" />
    {/* Camera lens */}
    <circle cx="260" cy="238" r="14" fill="#111" stroke="#333" strokeWidth="1" />
    <circle cx="260" cy="238" r="9" fill="#0a0a0a" stroke="#e2001a" strokeWidth="1" />
    <circle cx="260" cy="238" r="5" fill="#050505" />
    {/* Lens glint */}
    <circle cx="255" cy="233" r="2.5" fill="rgba(255,255,255,0.18)" />
    {/* Gimbal stabilizer bars */}
    <rect x="236" y="229" width="6" height="18" rx="3" fill="#222" stroke="#333" strokeWidth="0.5" />
    <rect x="278" y="229" width="6" height="18" rx="3" fill="#222" stroke="#333" strokeWidth="0.5" />

    {/* ── LANDING GEAR ── */}
    <line x1="228" y1="222" x2="218" y2="268" stroke="#1a1a1a" strokeWidth="5" strokeLinecap="round" />
    <line x1="292" y1="222" x2="302" y2="268" stroke="#1a1a1a" strokeWidth="5" strokeLinecap="round" />
    <line x1="204" y1="268" x2="232" y2="268" stroke="#1a1a1a" strokeWidth="5" strokeLinecap="round" />
    <line x1="288" y1="268" x2="316" y2="268" stroke="#1a1a1a" strokeWidth="5" strokeLinecap="round" />

    {/* ── STATUS LEDS ── */}
    {/* Front left - green */}
    <circle cx="210" cy="165" r="4" fill="#00ff88" opacity="0.9">
      <animate attributeName="opacity" values="0.9;0.3;0.9" dur="1.5s" repeatCount="indefinite" />
    </circle>
    {/* Front right - green */}
    <circle cx="310" cy="165" r="4" fill="#00ff88" opacity="0.9">
      <animate attributeName="opacity" values="0.9;0.3;0.9" dur="1.5s" repeatCount="indefinite" />
    </circle>
    {/* Rear left - red */}
    <circle cx="210" cy="210" r="4" fill="#e2001a" opacity="0.9">
      <animate attributeName="opacity" values="0.9;0.2;0.9" dur="0.8s" repeatCount="indefinite" />
    </circle>
    {/* Rear right - red */}
    <circle cx="310" cy="210" r="4" fill="#e2001a" opacity="0.9">
      <animate attributeName="opacity" values="0.9;0.2;0.9" dur="0.8s" repeatCount="indefinite" />
    </circle>

    {/* ── OBSTACLE SENSORS ── */}
    <rect x="195" y="162" width="8" height="8" rx="2" fill="#0a0a0a" stroke="#333" strokeWidth="0.5" />
    <rect x="317" y="162" width="8" height="8" rx="2" fill="#0a0a0a" stroke="#333" strokeWidth="0.5" />

    {/* ── DJI LOGO TEXT ── */}
    <text x="260" y="176" textAnchor="middle" fill="#ffffff" fontSize="11" fontWeight="800"
      fontFamily="Arial, sans-serif" letterSpacing="2" opacity="0.7">DJI</text>

    {/* ── SHADOW BELOW DRONE ── */}
    <ellipse cx="260" cy="310" rx="110" ry="12" fill="rgba(0,0,0,0.12)" />

    <style>{`
      @keyframes spinProp {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
    `}</style>
  </svg>
);

export default DroneSVG;